export default function Loading() {
  return (
    <div className='absolute inset-0 z-50 flex items-center justify-center bg-background backdrop-blur-sm'>
      <div className='flex flex-col items-center space-y-4'>
        <div className='h-8 w-8 animate-spin rounded-full border-b-2 border-primary'></div>
        <p className='text-sm text-muted-foreground'>Loading...</p>
      </div>
    </div>
  );
}
